import { createIsomorphicFn } from '@tanstack/react-start';
import { setResponseStatus } from '@tanstack/react-start/server';

const setStatusCode = createIsomorphicFn().server((code: number) => {
  setResponseStatus(code);
});

export const setStatusCode404 = () => setStatusCode(404);
